export function parseAmount(text: string): number | undefined {
  const textWithoutWhitespace = text.replace(/\s/g, "");
  const centsMatch = textWithoutWhitespace.match(/^([0-9,.]*\d)[.,](\d{1,2})$/);
  let cents;
  let dollars;
  if (centsMatch) {
    const centsString = centsMatch[2];
    cents = Number(centsString) * (centsString.length === 1 ? 10 : 1);
    dollars = Number(centsMatch[1]);
  } else if (textWithoutWhitespace.match(/^[0-9,.]+$/)) {
    cents = 0;
    dollars = Number(textWithoutWhitespace);
  } else {
    cents = NaN;
    dollars = NaN;
  }
  if (Number.isFinite(dollars) && Number.isFinite(cents)) {
    return dollars * 100 + cents;
  }
  return undefined;
}

export function formatAmount(locale: string, value: number): string {
  return new Intl.NumberFormat(
    locale,
    value % 1 === 0
      ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
      : { minimumFractionDigits: 2 }
  ).format(value / 100);
}

export function currencySymbol(locale: string, currency: string): string {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
    .format(7)
    .replace(/7/g, "")
    .trim();
}
